import getUrlPath from '../../../utils/getUrlPath';
import Loader from '../../../components/Loader';
import React, { useEffect, useState } from 'react';
import useCategories from '../../../hooks/useCategories';
import { AnchorLink, LoaderContainer, Root } from './CategoryLinksStyle';
import { Category } from '../../../types/categories';
import { FormattedMessage } from 'react-intl';
import { url } from '../../../constants/url';

interface CategoryLinksProps {
  slug: string;
}

function CategoryLinks({ slug }: CategoryLinksProps) {
  const { category, isCategoriesLoading } = useCategories(slug);
  const [subCategories, setSubCategories] = useState<Category[]>([]);

  useEffect(() => {
    const list = (category?.subCategories ?? []).filter(
      (subCategory) => subCategory.parentCategorySlug === category?.slug,
    );
    setSubCategories(list);
  }, [category]);

  if (isCategoriesLoading) {
    return (
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    );
  }

  if (!category?.subCategories || category?.subCategories?.length === 0) {
    return null;
  }

  return (
    <Root>
      <AnchorLink href={`${getUrlPath(url.rental.subPath.categories)}/${category.slug}`}>
        <FormattedMessage id='categories.all' /> {category?.name}
      </AnchorLink>
      {subCategories.map((e, i) => (
        <React.Fragment key={i}>
          <AnchorLink href={`${getUrlPath(url.rental.subPath.categories)}/${e.slug}`}>
            {e.name}
          </AnchorLink>
        </React.Fragment>
      ))}
    </Root>
  );
}

export default CategoryLinks;
